export enum SortingDirectionEnum {
  Ascend = 'ascend',
  Descend = 'descend',
}
